import { addMinutes, format } from 'date-fns';
import { memo } from 'react';
import { TIMESCALE } from 'tvm-config';

export interface TimeBarProps {
  firstFetchDate: Date;
}

export const TimeBar = memo(({ firstFetchDate }: TimeBarProps) => {
  return (
    <div className="relative ml-24 h-10 md:ml-52">
      {[...Array(60)].map((_, index) => (
        <div
          key={index}
          className="absolute bottom-2.5 border-gray-650/65 border-l-2 pl-2 font-bold text-sm text-white tracking-2px"
          style={{ left: `${index * TIMESCALE * 30}px` }}
        >
          {format(addMinutes(new Date(firstFetchDate), 30 * index), 'HH:mm')}
        </div>
      ))}
    </div>
  );
});

TimeBar.displayName = 'TimeBar';
